module.exports = __webpack_public_path__ + "img/motorway_9x2_z16.07aed13f.svg";